<template>
    <transition name="fade">
        <div class="notification" :class="type" v-if="isOpen">
            <div class="info_wrapper">
                <div class="info_content">
                    <div class="flex p-5">
                        <div class="pr-4" v-if="type=='success'">
                            <svg class="mt-1 h-6 w-6 text-green-400" viewBox="0 -90 512 512"  fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="m444.175781 0-260.871093 242.011719-110.324219-117.734375-72.980469 68.386718 178.234375 190.207032 333.765625-309.351563zm0 0"/></svg>
                        </div>
                        <div class="pr-4" v-if="type=='error'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mt-1 h-8 w-8" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" /></svg>
                        </div>
                        <div class="pr-4" v-if="type=='warning'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mt-1 h-7 w-7 text-yellow-200" fill="currentColor"
                            viewBox="0 0 512 512" xml:space="preserve">
                            <path d="M256,0C114.613,0,0,114.617,0,256c0,141.391,114.613,256,256,256s256-114.609,256-256C512,114.617,397.387,0,256,0z M256,128c17.674,0,32,14.328,32,32c0,17.68-14.326,32-32,32s-32-14.32-32-32C224,142.328,238.326,128,256,128z M304,384h-96 c-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h16v-96h-16c-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h64 c8.836,0,16,7.164,16,16v112h16c8.836,0,16,7.164,16,16C320,376.844,312.836,384,304,384z"/></svg>
                        </div>
                        <div class="pr-4" v-if="type=='info'">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mt-1 h-7 w-7 text-green-200" fill="currentColor"
                            viewBox="0 0 512 512" xml:space="preserve">
                            <path d="M256,0C114.613,0,0,114.617,0,256c0,141.391,114.613,256,256,256s256-114.609,256-256C512,114.617,397.387,0,256,0z M256,128c17.674,0,32,14.328,32,32c0,17.68-14.326,32-32,32s-32-14.32-32-32C224,142.328,238.326,128,256,128z M304,384h-96 c-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h16v-96h-16c-8.836,0-16-7.156-16-16c0-8.836,7.164-16,16-16h64 c8.836,0,16,7.164,16,16v112h16c8.836,0,16,7.164,16,16C320,376.844,312.836,384,304,384z"/></svg>
                        </div>
                        <div>
                            <h4 class="m-0 text-base md:text-lg font-bold" v-html="title"></h4>
                            <p v-html="content"></p>
                        </div>
                    </div>
                </div>
                <div class="absolute right-5 top-5 z-5" v-if="showClose">
                    <button @click="this.isOpen = false" >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 cursor-pointer opacity-60 hover:opacity-100" fill="currentColor" viewBox="0 0 365.696 365.696" xml:space="preserve"><path d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0"/></svg>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default({
    name: 'Notification',
    props: {
        title : String,
        content: String,
        type: String,
        showClose :  {
            type: Boolean,
            default : true
        }
    },
    data: () => {
            return {
                isOpen: true
            }
        },
    method(){
        
    },
    // STATUS: success, error, warning, info
})
</script>


<style>
.notification {
    @apply rounded-lg mb-5 relative;
}
.info_wrapper {
    @apply rounded-lg overflow-hidden
}
.notification.success .info_wrapper{
    @apply border-green-400 bg-ltGreen text-green-400;
    border-left-width: 12px;
}
.notification.error .info_wrapper{
    @apply border-error-200 bg-error-100 text-error-200;
    border-left-width: 12px;
}
.notification.warning .info_wrapper {
    @apply border-yellow-200 bg-yellow-100 text-green-500;
    border-left-width: 12px;
}
.notification.info .info_wrapper{
    @apply border-gray-200 bg-white text-green-500 border;
    border-left: 12px solid #258c22;
}
</style>